
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useStudentActivitiesSchedule = (studentId: string, activityIds: string[]) => {
  return useQuery({
    queryKey: ['student-activities-schedule', studentId, activityIds],
    queryFn: async () => {
      if (!studentId || !activityIds.length) return {};
      
      
      // Batch fetch all schedules in a single query
      const { data, error } = await supabase
        .from('student_activity_schedule')
        .select('activity_id, day_of_week')
        .eq('student_id', studentId)
        .in('activity_id', activityIds);
      
      if (error) {
        throw error;
      }
      
      // Group schedules by activity_id
      const schedulesByActivity: Record<string, number[]> = {};
      
      // Initialize empty arrays for all activity IDs
      activityIds.forEach(id => {
        schedulesByActivity[id] = [];
      });
      
      // Fill in the data we have
      (data || []).forEach(schedule => {
        schedulesByActivity[schedule.activity_id].push(schedule.day_of_week);
      });
      
      
      
      return schedulesByActivity;
    },
    enabled: !!studentId && activityIds.length > 0,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
